import { render, staticRenderFns } from "./projectsOverviewCard.vue?vue&type=template&id=bb156c7a"
import script from "./projectsOverviewCard.vue?vue&type=script&lang=ts"
export * from "./projectsOverviewCard.vue?vue&type=script&lang=ts"
import style0 from "./projectsOverviewCard.vue?vue&type=style&index=0&id=bb156c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports